import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { environment } from '../../environments/environment';

@Injectable({
	providedIn: 'root'
})
export class CategoriaDespesaService {
	private data = null;
	private url = environment.serviceApi;

	constructor(public http: Http) { }

	getCategoriasDespesa(ordem=null) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/categoriasdespesa' + (ordem? '/ordem/' + ordem : ''))
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	getCategoriaDespesa(id) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/categoriasdespesa/' + id)
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	criaCategoriaDespesa(data) {
		return new Promise((resolve, reject) => {
			this.http.post(this.url + '/categoriasdespesa', {
				categoria_despesa_nome: data.categoria_despesa_nome,
			})
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	editaCategoriaDespesa(data) {
		return new Promise((resolve, reject) => {
			this.http.put(this.url + '/categoriasdespesa/' + data.categoria_despesa_id, {
				categoria_despesa_nome: data.categoria_despesa_nome,
			})
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	apagaCategoriaDespesa(id) {
		return new Promise((resolve, reject) => {
			this.http.delete(this.url + '/categoriasdespesa/' + id)
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}
}
